/**
 * "You are not signed in any more" — said once, heard everywhere.
 *
 * A session can end while the page stays open, and when it does every request starts
 * answering 401. The gate only checked at mount, so the app kept its whole interface
 * and each button quietly did nothing. That is how a 30-minute login was diagnosed for
 * an hour across three services as a delivery fault: the failure never said its name,
 * it just stopped producing effects.
 *
 * Any caller that sees a 401 says so here. Nothing polls; this only ever fires because
 * a request the user's own action made came back refused.
 */
const listeners = new Set<() => void>()

export function onSignedOut(cb: () => void): () => void {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

export function notifySignedOut(): void {
  for (const cb of [...listeners]) cb()
}
